import styled from 'styled-components';

const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export default Img;
